export function supportsPassiveEventListeners() {
    let supportsPassive = false;
    try {
        const opts = Object.defineProperty({}, 'passive', {
            get: () => {
                supportsPassive = true;
            },
        });
        window.addEventListener('test', () => null, opts);
    } catch (e) {
        // Catch body can be empty because if the 'passive' property doesn't exist, then the empty catch block will be executed, leading to the supportsPassive variable staying false.
    }

    return supportsPassive;
}
